import { schema } from 'normalizr';

const buildRel = (noindex, nofollow) => {
  const relParts = [];

  if (parseInt(noindex, 10)) {
    relParts.push('noindex');
  }

  if (parseInt(nofollow, 10)) {
    relParts.push('nofollow');
  }

  return relParts.join(', ');
};

export const convertorLink = new schema.Entity(
  'convertorLinks',
  {},
  {
    processStrategy: ({
      children,
      noindex,
      nofollow,
      status,
      id,
      name,
      url,
    }) => ({
      id,
      name,
      url,
      rel: buildRel(noindex, nofollow) || undefined,
      active: !!parseInt(status, 10),
      children: (children || []).map(
        ({
          noindex: childNoindex,
          nofollow: childNofollow,
          status: childStatus,
          id: childId,
          name: childName,
          url: childUrl,
        }) => ({
          id: childId,
          name: childName,
          url: childUrl,
          rel: buildRel(childNoindex, childNofollow) || undefined,
          active: !!parseInt(childStatus, 10),
        })
      ),
    }),
  }
);

export const convertorLinks = [convertorLink];

export default convertorLinks;
